

import { useState, useEffect } from "react"
import { Calendar } from "react-multi-date-picker"


const DatePickerTimeslotMultipleDate = (props: any) => {
  let date: any = props.date ?? [];
  let dates: any = date;
  let minDate = ((props.minDate) ? new Date(props.minDate) : new Date());
  let maxDate = ((props.maxDate) ? new Date(props.maxDate) : undefined);
  const [values, setValues] = useState(dates)

  useEffect(() => {
    setValues(dates)

  }, [date])
  const months = ["Gen", "Feb", "Mar", "Apr", "mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"]
  const weekDays = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"]
  return (
    <>
      <Calendar
        weekStartDayIndex={1}
        multiple
        value={values}
        months={months}
        minDate={((new Date() < minDate) ? minDate : new Date())}
        maxDate={maxDate}
        weekDays={weekDays}
        onChange={(e: any) => (setValues(e), props.handleChange(e.map((value: any) => value.format())))}
      />
    </>
  )
}
export default DatePickerTimeslotMultipleDate